import apiV2 from "api-v2";
import { AxiosResponse } from "axios";
import { downloadFileNoPopup } from "helpers/linkHelper";
import { Rfx } from "newui/features/Rfx/types/rfx.types";
import { FileableFile } from "types/storage.types";
import { showToast } from "utils/helpers";
import {
	endPerformance,
	logPerformance,
	startPerformance,
} from "utils/logging";

export const downloadAllDocumentation = async (rfx: Rfx) => {
	try {
		let file = rfx.rfxDocumentationZipFile;

		if (!file?.file_path) {
			const response = await apiV2.get<AxiosResponse<FileableFile>>(
				`rfq/${rfx.id}/download-documents`
			);

			if (response.status === 200 && response.data?.data) {
				file = response.data.data;
			} else {
				return false;
			}
		}

		downloadFileNoPopup(file.file_path, file.file_name);
	} catch (e) {
		showToast("Failed to download documents", "Error");
		return false;
	}
};

export interface CreateRfxPayload {
	project_id: number;
	supplier_list_id?: number | string;
	template_id?: number | string;
}

export const createRfx = async (
	data: CreateRfxPayload
): Promise<Rfx | null> => {
	try {
		const { data: response } = await apiV2.post("rfq/store", data);
		if (response.status) {
			showToast(response?.message, response?.title, true);
			return response.data as Rfx;
		} else {
			showToast(response?.message, response?.title);
			return null;
		}
	} catch (err: any) {
		const errorData = err?.response?.data;
		if (err?.response?.status === 422 && errorData?.errors) {
			const firstError = Object.values(errorData.errors)[0];
			const errorMessage = Array.isArray(firstError)
				? firstError[0]
				: firstError;
			showToast(
				errorMessage as string,
				errorData?.title || "Validation Error"
			);
		} else {
			showToast(errorData?.message || "An error occurred", "Error");
		}
		return null;
	}
};

export const getRfxById = async (
	id: number,
	includes: string[] | null = null
): Promise<Rfx | null> => {
	const startTime = startPerformance();
	try {
		const request = `rfq/${id}${includes ? `?include=${includes.join(",")}` : ""}`;
		const { data: rfq } = await apiV2.get(request);
		if (rfq.status) {
			return rfq.data as Rfx;
		} else {
			return null;
		}
	} catch (err) {
		return null;
	} finally {
		const endTime = endPerformance();
		logPerformance(startTime, endTime, "getRfxById");
	}
};
